<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container w-min-600">
          <div class="modal-header">
            <slot name="header">
              New User
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <div class="row">
                <div class="col-2">
                  <label for="email">Email:</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="email"
                    ref="user_email"
                    name="email"
                    autocomplete="username"
                    placeholder="email"
                    v-model="email"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="description">Description:</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="description"
                    ref="user_description"
                    name="description"
                    placeholder="description"
                    autocomplete="name"
                    v-model="description"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="password">Password:</label>
                </div>
                <div class="col-9">
                  <input
                    type="password"
                    class="form-control"
                    id="password"
                    autocomplete="new-password"
                    ref="user_password"
                    name="password"
                    placeholder="password"
                  />
                </div>
              </div>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="_save">
                Save &amp; Close
              </button>
              <button class="btn btn-plt" @click="$emit('close')">
                Cancel
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "NewUserModal",
  data: () => ({
    email: "",
    description: "",
  }),
  methods: {
    ...mapActions("users", ["apiCreateUser"]),
    _save() {
      if (!this.$refs.user_email.value) {
        alert("please enter an email");
        return;
      } else if (!this.$refs.user_description.value) {
        alert("please enter a description");
        return;
      } else if (!this.$refs.user_password.value) {
        alert("please enter a password");
        return;
      }
      var user = {
        id: 0,
        email: this.$refs.user_email.value,
        description: this.$refs.user_description.value,
        password: this.$refs.user_password.value,
        admin: false,
        active: true,
      };
      this.apiCreateUser(user);
      this.$emit("close");
    },
    clear() {
      this.email = "";
      this.description = "";
      this.$refs.user_password.value = "";
    },
  },
  components: {},
};
</script>
